<script lang="ts">
  import { surrenderDetail, surrenderHeadline, type SurrenderView } from '../../game/surrender';

  interface Props {
    view: SurrenderView;
    onvote: (agree: boolean) => void;
  }

  const { view, onvote }: Props = $props();

  const open = $derived(view.phase === 'voting');
  const callable = $derived(view.phase === 'available');
</script>

<div class="surrender" class:surrender--open={open} data-testid="surrender-panel">
  <p class="surrender__headline" data-testid="surrender-headline">{surrenderHeadline(view)}</p>
  <p class="surrender__detail" data-testid="surrender-detail">{surrenderDetail(view)}</p>

  {#if open}
    <div class="surrender__actions">
      <button
        class="wis-btn-inline surrender__action"
        type="button"
        data-testid="surrender-yes"
        disabled={view.youVoted}
        onclick={() => {
          onvote(true);
        }}>Yes</button
      >
      <button
        class="wis-btn-inline surrender__action"
        type="button"
        data-testid="surrender-no"
        disabled={view.youVoted}
        onclick={() => {
          onvote(false);
        }}>No</button
      >
    </div>
  {:else if callable}
    <div class="surrender__actions">
      <button
        class="wis-btn-inline surrender__action surrender__action--call"
        type="button"
        data-testid="surrender-call"
        onclick={() => {
          onvote(true);
        }}>Call vote</button
      >
    </div>
  {/if}
</div>

<style>
  /* Right edge under the leaderboard, which is 240px tall and the only thing in that corner. */
  .surrender {
    position: absolute;
    top: 262px;
    right: 12px;
    width: 214px;
    padding: 8px 10px 10px;
    color: #e6ebf7;
    background:
      repeating-linear-gradient(45deg, rgb(255 255 255 / 5%) 0 2px, transparent 2px 4px),
      linear-gradient(#242423, #171716);
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 26%),
      inset 0 -1px 0 rgb(0 0 0 / 60%),
      0 2px 6px rgb(0 0 0 / 70%);
    pointer-events: auto;
  }

  .surrender--open {
    box-shadow:
      inset 0 0 0 1px #d8c07a,
      inset 0 1px 0 rgb(255 255 255 / 26%),
      0 2px 6px rgb(0 0 0 / 70%);
  }

  .surrender__headline {
    margin: 0;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .surrender__detail {
    margin: 3px 0 0;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #97a0b6;
  }

  .surrender__actions {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }

  .surrender__action {
    flex: 1 1 0;
    padding: 6px 8px;
    font-size: 11px;
  }

  .surrender__action:disabled {
    opacity: 0.45;
    cursor: default;
  }
</style>
